import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import { IconArrowLink, IconClose } from '../../1-foundation/icons/icons';
import { modifierList as iconsModifiersList } from '../../1-foundation/icons/props-list';

import { modifierList } from './props-list';

const DEFAULT_MODIFIERS = [];

const BannerMarketing = ({ imgSrc, text, modifiers = DEFAULT_MODIFIERS, showArrowIcon, onClose, iconsColor }) => {
  const classNames = getClassNames('c-banner-marketing', modifiers);
  const showCloseBtn = Boolean(onClose);

  return (
    <aside className={classNames}>
      {imgSrc && (
        <div className="c-banner-marketing__wrap-image">
          <img crossOrigin="anonymous" className="c-banner-marketing__img" src={imgSrc} />
        </div>
      )}
      <p className="c-banner-marketing__text">{text}</p>
      {showArrowIcon && <IconArrowLink modifiers={[iconsColor, 'arrow-navigation', 'arrow-link', 'small']} />}
      {showCloseBtn && (
        <button className="c-banner-marketing__close" type="button" onClick={onClose}>
          <IconClose modifiers={['navigation', 'close', 'xsmall', 'c-medium-light-2']} />
        </button>
      )}
    </aside>
  );
};

BannerMarketing.propTypes = {
  imgSrc: PropTypes.string,
  text: PropTypes.string.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  showArrowIcon: PropTypes.bool,
  onClose: PropTypes.func,
  iconsColor: PropTypes.oneOf(iconsModifiersList).isRequired,
};

export default BannerMarketing;
